import { type NodeProps } from '@xyflow/react'
import clsx from 'clsx'

import type { DisplayGroupNode as DisplayGroupNodeType } from '../../ProgramStateMachine.types'

import styles from './DisplayGroupNode.module.scss'

export function DisplayGroupNode({ data, selected }: NodeProps<DisplayGroupNodeType>) {
  return (
    <div
      className={clsx(styles.groupNode, selected && styles.selected)}
      data-testid={`display-group-node-${data.groupName}`}
    >
      <span className={styles.label}>{data.label}</span>
    </div>
  )
}
